// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuUser__block-3OmO-","avatar":"MainMenuUser__avatar-1E_zh","title":"MainMenuUser__title-3XiGh"};